// extracted by mini-css-extract-plugin
module.exports = {"button":"button-9nuGV","icon":"icon-2dthV","paper":"paper-1Sm2E"};